import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable, of } from 'rxjs';
import { BackgroundDashboardService } from '../../shared/services/backgroundDashboard.service';

@Component({
    selector: 'view-progress-dialog',
    templateUrl: './viewProgressDialog.componen.html',
})
export class ViewProgressDialogComponent {

    public GetServicesDetail: any;

    constructor(public dialogRef: MatDialogRef<ViewProgressDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, public vcRef: ViewContainerRef, private BackgroundDashboardService: BackgroundDashboardService) {
        this.GetServicesDetail = this.data.newObj;
        dialogRef.disableClose = true;
    }

    ngOnInit() { }



    onNoClick(): void {
        this.dialogRef.close();
    }

}